import React, { useEffect, useState } from "react";
import Axios from "axios";
import {  GetCandidateOutreachdetails, GetListOfVendorsByEmployeeID, GetJobPosts } from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import nodataimg from "../assets/images/Nodata.jpg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ReactPaginate from "react-paginate";
import { useCountry } from "../contexts/countrycodecontext.js";
import { useForm } from "react-hook-form";
import {Modal, Button } from 'react-bootstrap';
import Select from 'react-select';

const OverallOutreachCandidates = () => {

  const [evaluations, setEvaluations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [viewType, setViewType] = useState("list"); // default list view
    const [showIcon, setShowIcon] = useState('list');
const [currentPage, setCurrentPage] = useState(0);
const itemsPerPage = 25; 
const [searchTerm, setSearchTerm] = useState("");
const { selectedCountry} = useCountry();
  const [showFilterModal,setShowFilterModal] = useState(false);
    const [vendorData, setVendorData] = useState([]);
    const { register, control, formState: { errors, isSubmitting }, setValue, reset } = useForm();
 const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" }, // Default case
     { value: "Past 2 years", label: "Past 2 years" }, // Default case
      { value: "Past 3 years", label: "Past 3 years" }, // Default case

  ];
      const [jobPosts, setJobPosts] = useState([]);
  const appliedfilter = localStorage.getItem("candidateOutreachFilters")
 let Guid="";
    const guid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const token = localStorage.getItem("jwtToken");
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }
  const [filters, setFilters] = useState({
    UserGuid: Guid,
    FullName: "",
    Email: "",
  });
const fetchJobPosts = async (JobRoleID, vendorGuid) => {
      setIsLoading(true);

      try {
        const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Filter based on selected Job Role and Vendor (client)
        const filteredPosts = response.data.filter((x)=>x.status =='Active')
            console.log(filteredPosts)
    
        setJobPosts(filteredPosts);
      } catch (error) {
        console.error("Error fetching job posts", error);
      } finally {
        setIsLoading(false);
      }
    };
  const GetVendorsList = () => {
    setIsLoading(true);
  
    const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  
    Axios.get(GetapiUrl)
      .then((result) => {
        setIsLoading(false);
  
        setVendorData(result.data);
      }).catch((error) => {
        console.log("Error" + error);
      });
  };

const handlePageClick = ({ selected }) => {
  setCurrentPage(selected);
};

 const handleViewToggle = (type) => {
        setViewType(type);
        setShowIcon(type)
      };

const handleCancelSearch = () => {
  setShowFilterModal(false);
};
const saveFiltersToStorage = (filterData) => {
  localStorage.setItem("candidateOutreachFilters", JSON.stringify(filterData));
};

     const loadFiltersFromStorage = () => {
  const storedFilters = localStorage.getItem("candidateOutreachFilters");
  if (storedFilters) {
    const parsed = JSON.parse(storedFilters);

    // ✅ Map stored keys to filter state keys used in UI
    setFilters({
      ...filters,
      VendorGuid: parsed.searchCompanyName || "",
      jobTitleID: parsed.searchJobTitle ? parseInt(parsed.searchJobTitle) : null,
      SubmittedDate: parsed.date || "",
    });

    // ✅ Update modal form values also
    reset({
      vendorCompanyName: parsed.searchCompanyName || "",
      jobTitleID: parsed.searchJobTitle || null,
    });
  }
};

 const handleVendorChange = (event) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        VendorGuid: event.target.value, // ✅ Store as a string
      }));
    };

       const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription // Store job description for later use
      }));

       const handleFilterChange = (selectedOption) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        SubmittedDate: selectedOption.label, // ✅ Store label for API
      }));
    };
const applyFilters = async () => {
  setIsLoading(true);
  setShowFilterModal(false);

  const applied = {
    userGuid: Guid,
    countryId: selectedCountry || 0,
    searchName: null, // or filters.searchName if you have it
    searchEmail: null,
    searchJobTitle: filters.jobTitleID ? String(filters.jobTitleID) :null,
    searchCompanyName: filters.VendorGuid || null,
    date: filters.SubmittedDate || null,
  };

  saveFiltersToStorage(applied);
  setFilters(applied);

  try {
   const response = await Axios.post(
  GetCandidateOutreachdetails.APIURL,
  applied,   // ← JSON body
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  }
);
// ✅ send payload in body
    setEvaluations(response.data);
  } catch (e) {
    console.error("Filter API Error:", e);
  } finally {
    setIsLoading(false);
  }
};


const fetchEvaluations = async () => {
  setIsLoading(true);
  try {
    const payload = {
      userGuid: Guid,
      countryId: selectedCountry,
      searchName: null,
      searchEmail: null,
      searchJobTitle: null,
      searchCompanyName: null,
      date: null,
    };

const res = await Axios.post(
  GetCandidateOutreachdetails.APIURL,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  }
);    const data = res.data || [];
    setEvaluations(data);
  } catch (err) {
    console.error("Error fetching evaluations:", err);
  } finally {
    setIsLoading(false);
  }
};


useEffect(() => {
  const saved = localStorage.getItem("candidateOutreachFilters");

  if (saved) {
    loadFiltersFromStorage();
    applyFilters(); // Fetch using filters
  } else {
    fetchEvaluations(); // Normal call
  }
}, [Guid, selectedCountry]);


useEffect(() => {
  GetVendorsList();
   fetchJobPosts();
}, [selectedCountry]); 

const handleFilterSearch = () => {
  loadFiltersFromStorage();
  setShowFilterModal(true);
};


const handleRefresh = () => {
  setSearchTerm("");
  localStorage.removeItem("candidateOutreachFilters");

  setFilters({
    UserGuid: Guid,
    FullName: "",
    Email: "",
    VendorGuid: "",
    jobTitleID: null,
    SubmittedDate: ""
  });

  reset({ vendorCompanyName: "", jobTitleID: null });

  fetchEvaluations(); // Call initial API again
};


const filteredEvaluations = evaluations.filter((ev) =>
  [ev.fullName, ev.email,ev.vendorCompanyName,ev.vendorName]?.some((field) =>
    field?.toLowerCase().includes(searchTerm.toLowerCase())
  )
);

// Pagination based on filtered list
const offset = currentPage * itemsPerPage;
const currentItems = filteredEvaluations.slice(offset, offset + itemsPerPage);
const pageCount = Math.ceil(filteredEvaluations.length / itemsPerPage);


  return (
    <ConsultantLayout>
       
      <div className="container-fluid mt-3">
    <div class="responsive-container" style={{display:'flex',justifyContent:'space-between'}}>
     <div style={{ display: "flex", alignItems: "center" }}>
    <Link to="/Employer/GetCandidatesByEmployerUserID">
      <i  className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: 10 }}
        aria-hidden="true" ></i>
    </Link>
    <h2 style={{ color: "#00a7ac", margin: 0 }}>List of Outreach Candidates</h2>
  </div>

<div style={{display:'flex',justifyContent:'space-between'}}>

              <div>
            {showIcon === 'grid' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                    <button
                                      className="btn btn-primary mr-3"
                                      onClick={() => handleViewToggle('list')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
              )}
              {showIcon === 'list' && (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                  <button
                    className="btn btn-primary mr-3"
                    onClick={() => handleViewToggle('grid')}
                    style={{ backgroundColor: "#00a7ac" }}
                  >
                    <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                  </button>
                </OverlayTrigger>
              )}
           </div>
              
  
  </div>

        </div>
       
       <div className="row mt-3">
  <div className="col d-flex align-items-center">

    {/* Search Box */}
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>
          Search by Name or Email or Client Name or Company Name
        </Tooltip>
      )}
    >
      <input
        type="text"
        className="form-control"
        placeholder="Search by Name or Email or Client Name or Company Name"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setCurrentPage(0);
        }}
        style={{
          padding: "0 10px",
          border: "1px solid #ccc",
          height: 45,
          borderRadius: 6,
          minWidth: 280,
          marginRight: 10
        }}
      />
    </OverlayTrigger>

    {/* Apply Filter Btn */}
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>
          {appliedfilter == null ? "Apply Filter" : "Filter Applied"}
        </Tooltip>
      )}
    >
      <button
        className="btn btn-primary mr-2"
        onClick={handleFilterSearch}
        style={{ height: 45, display: "flex", alignItems: "center", gap: 6 }}
        type="button"
      >
        <i className="fas fa-filter"></i>
        {appliedfilter == null ? "Apply Filter" : "Filter Applied"}
      </button>
    </OverlayTrigger>

    {/* Reset Filter Btn */}
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>
          Reset Filter
        </Tooltip>
      )}
    >
      <button
        className="btn btn-secondary"
        onClick={handleRefresh}
        style={{ height: 45, display: "flex", alignItems: "center", gap: 6 }}
        type="button"
      >
        <i className="fas fa-sync"></i>
        Reset
      </button>
    </OverlayTrigger>

  </div>
</div>

        <hr />
               {isLoading ? (
          <center>
            <LoadingSpinner />
          </center>
        ) : filteredEvaluations.length === 0 ? (
          <div style={{ textAlign: "center" }}>
            <img
              src={nodataimg}
              alt="No Data"
              style={{ width: "100%", maxWidth: "500px" }}
            />
          </div>
        ) : 
        viewType === "list" ? (
          // Table View
         <table className="table mt-3" 
        style={{ minWidth: "100%", fontSize: "12px", tableLayout: "fixed", wordWrap: "break-word", }}>
            <thead style={{ background: "#f8f9fa" }}>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile Number</th>
                <th>Job Title</th>
                <th>Clientname - Company Name</th>
                <th>Staffing Contact Email</th>
                <th>Email sent Date </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((ev, idx) => (
                <tr key={idx}>
                  <td>{ev.fullName}</td>
                  <td>{ev.email}</td>
                  <td>{ev.mobileNumber}</td>
                   <td>{ev.jobTitle}</td>
                   <td>{ev.vendorName} - {ev.vendorCompanyName}</td>
                   <td>{ev.vendorEmail}</td>
                   <td>{ev.sendDate.split('T')[0]}</td>
                  <td>
<Link
  to={`/Employer/OutreachViewCandidateDetailsByCandidateGUid?guid=${ev.guid}`}
>
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip>View Candidate Details</Tooltip>}
  >
    <button
      style={{
        background: "none",
        border: "none",
        marginLeft: 8, // spacing between icons
      }}
    >
      <i
        className="fa fa-user"
        aria-hidden="true"
        style={{ fontSize: 16, color: "#00a7ac" }}
      ></i>
    </button>
  </OverlayTrigger>
</Link>

</td>

                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          // Grid View
          <div className="row">
            {currentItems.map((ev, idx) => (
                           <div className="col-md-6 col-lg-4 mb-3 mt-3" key={idx}>
                <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', borderRadius: 20, height: 350 }}>
                                
                                   <div className='card-body' style={{ height: 400 }}>
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="positions-tooltip" {...props}>Name</Tooltip>)}>
                      <p style={{ fontSize: 14 }}>
                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i>  {ev.fullName}
                      </p>
                    </OverlayTrigger>

                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="location-tooltip" {...props}>Email</Tooltip>)}>
                      <p style={{ fontSize: 14 }}>
                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i>
                        {ev.email} 

                      </p>
                    </OverlayTrigger>
                       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="location-tooltip" {...props}>Mobile Number</Tooltip>)}>
                      <p style={{ fontSize: 14 }}>
                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i>
                        {ev.mobileNumber} 

                      </p>
                    </OverlayTrigger>
               <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Job Title</Tooltip>)}>
                    <p  style={{fontSize: 14 }}> <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i>{ev.jobTitle}</p>
                  </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="clientname-tooltip" {...props}>Client Name - Company Name</Tooltip>)}>
                                                 <p style={{ fontSize: 14 }}>
                                                     <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user-tie" aria-hidden="true"></i> {ev.clientName} {ev.vendorCompanyName? ` - ${ev.vendorCompanyName}` : ""}
                                                 </p>
                                             </OverlayTrigger>
   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="clientname-tooltip" {...props}>Staffing Contact Email</Tooltip>)}>
                                                 <p style={{ fontSize: 14 }}>
                                                     <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {ev.vendorEmail}
                                                 </p>
                                             </OverlayTrigger>
                                                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="clientname-tooltip" {...props}>Email Sent Date</Tooltip>)}>
                                                 <p style={{ fontSize: 14 }}>
                                                     <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-calendar" aria-hidden="true"></i> {ev?.sendDate?.split('T')[0]}
                                                 </p>
                                             </OverlayTrigger>
      </div>
                                  <div className='card-footer text-center'>
                  <Link
                        to={`/Employer/OutreachViewCandidateDetailsByCandidateGUid?guid=${ev.guid}`}
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip>View Candidate Details</Tooltip>}
                        >
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              marginLeft: 8, // spacing between icons
                            }}
                          >
                            <i
                              className="fa fa-user"
                              aria-hidden="true"
                              style={{ fontSize: 16, color: "#00a7ac" }}
                            ></i>
                          </button>
                        </OverlayTrigger>
                      </Link>
                                  </div>
                                </div>
                </div>
            ))}
          </div>
        )}
      </div>

{filteredEvaluations.length > itemsPerPage && (
  <div className="d-flex justify-content-center mt-4">
    <ReactPaginate
      previousLabel={"Prev"}
      nextLabel={"Next"}
      breakLabel={"..."}
      breakClassName={"break-me"}
      pageCount={pageCount}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName={"pagination"}
      pageClassName={"page-item"}
      pageLinkClassName={"page-link"}
      previousClassName={"page-item"}
      nextClassName={"page-item"}
      previousLinkClassName={"page-link"}
      nextLinkClassName={"page-link"}
      activeClassName={"active"}
      disabledClassName={"disable-pagination-button"}
      forcePage={currentPage}  // keeps page in sync when filtering
    />
  </div>
)}
  <Modal show={showFilterModal} style={{ textAlign: 'center'}}  dialogClassName="custom-modal"  onHide={handleCancelSearch}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Filters </Modal.Title>
         </Modal.Header>
        <Modal.Body>
          <div className='row'>
                <div className='col-6'>  
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Client name</Tooltip>)}>
                    <select
                                            {...register("vendorCompanyName", { required: "Client Name Required" })}
                                            className={`form-control mt-3 ${errors.vendorCompanyName ? 'is-invalid' : ''}`}
                                           style={{height:50 ,borderRadius:15,fontSize:12}}
                                            onChange={handleVendorChange}
                                             value={filters.VendorGuid || ""}
                                        >
                                            <option value="">Select Client Name</option>
                                            {vendorData.map((vendor, index) => (
                                                <option key={index} value={vendor.vGuid}>{vendor.vendorName} - {vendor.vendorCompanyName}</option>
                                            ))}
                    </select>  
                    </OverlayTrigger>
                                <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Date Filter</Tooltip>)}>    
                    
                                    <Select
                        options={dateFilterOptions}
                        placeholder="Select Date Filter"
                        value={dateFilterOptions.find(option => option.label === filters.SubmittedDate) || null}
                        onChange={handleFilterChange}
                        className="mt-3"
                        styles={{
                            control: (provided) => ({
                            ...provided,
                            height: 50,
                            borderRadius: 10,
                            fontSize: "12px",
                            }),
                            placeholder: (provided) => ({
                            ...provided,
                            textAlign: "left",
                            fontSize: "12px",
                            }),
                            singleValue: (provided) => ({
                            ...provided,
                            textAlign: "left",
                            fontSize: "12px",
                            
                            }),
                        }}
                        />
                    </OverlayTrigger>
                    
                    
                </div>
             <div className="col-6">
  <OverlayTrigger
            placement="bottom"
            overlay={(props) => <Tooltip id="tooltip" {...props}>Select Job Title</Tooltip>}
          >
            <div className="mt-4">
              <Select
  options={jobTitleOptions}
  placeholder="Select Job Title"
  className="mt-3"
value={
    jobTitleOptions.find(option => option.value === filters.jobTitleID) || null
  }  
  onChange={(selectedOption) => {
    setFilters(prev => ({
      ...prev,
      jobTitleID: selectedOption ? selectedOption.value : null
    }));
  }}
  styles={{
    control: (provided) => ({
      ...provided,
      height: 50,
      borderRadius: 10,
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  }}
/>

            </div>
          </OverlayTrigger>
             </div>
             
          </div>
         
        </Modal.Body>
        <Modal.Footer style={{marginTop:100}}>
        <Button variant="primary" onClick={handleRefresh}>
      <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
    </Button>
          <Button variant="primary" onClick={applyFilters}>Apply</Button>
          <Button variant="secondary" onClick={handleCancelSearch}>Cancel</Button>

        </Modal.Footer>
      </Modal>
    </ConsultantLayout>
  );
};

export default OverallOutreachCandidates;
